let apiBaseOverride = '';
let hasProbed = false;
let fallbackUsed = false;
let probeResult: 'pending' | 'relative' | 'fallback' | 'failed' = 'pending';

export function getApiUrl(path: string): string {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    const relativePath = cleanPath.startsWith('/api/') ? cleanPath : `/api${cleanPath}`;
    
    // Support explicit environment override if provided
    const envBase = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_BASE) || '';
    if (envBase) {
        return `${envBase}${relativePath}`;
    }

    return `${apiBaseOverride}${relativePath}`;
}

export function setApiBaseOverride(base: string) {
    apiBaseOverride = base;
    fallbackUsed = base !== '';
}

export function getRoutingDiagnostics() {
    return {
        origin: typeof window !== 'undefined' ? window.location.origin : 'unknown',
        apiBase: apiBaseOverride || 'relative',
        hasProbed,
        fallbackUsed,
        probeResult
    };
}

export async function probeApiRoute(): Promise<boolean> {
    if (hasProbed) return !fallbackUsed;
    hasProbed = true;
    
    // On localhost, we always want to use the relative proxy
    if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
        apiBaseOverride = '';
        probeResult = 'relative';
        return true;
    }

    try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000); // 3s timeout for probe
        
        const res = await fetch('/api/_deploy_tag', { signal: controller.signal });
        clearTimeout(timeoutId);
        
        if (res.ok) {
            const contentType = res.headers.get('content-type') || '';
            if (contentType.includes('application/json')) {
                try {
                    const data = await res.json();
                    if (data && (data.deployTag || data.ok)) {
                        apiBaseOverride = '';
                        probeResult = 'relative';
                        return true;
                    }
                } catch {
                    // JSON parsing failed
                }
            }
        }
        // If we get HTML or non-JSON, fallback
        apiBaseOverride = 'https://corpora.wikiboox.com';
        fallbackUsed = true;
        probeResult = 'fallback';
        return false;
    } catch (e) {
        console.warn('[urlHelper] Relative API probe failed or timed out, falling back to corpora.wikiboox.com', e);
        apiBaseOverride = 'https://corpora.wikiboox.com';
        fallbackUsed = true;
        probeResult = 'failed';
        return false;
    }
}
